import classNames from 'classnames';

import { Svg } from '@components/Svg';

import { CmsRecipeDifficulty } from '@interfaces/common';
import { neverError } from '@utils/neverError';

import styles from './RecipeDifficultyIcon.module.css';

type Theme = 'dark' | 'light';

const getDifficultyValue = (difficulty: CmsRecipeDifficulty) => {
	switch (difficulty) {
		case 'Easy':
			return 1;

		case 'Medium':
			return 2;

		case 'Hard':
			return 3;

		default:
			throw neverError('Unknown difficulty type', difficulty);
	}
};

const getDifficultyIcons = (difficulty: CmsRecipeDifficulty, theme: Theme) => {
	const icons = [];

	for (let i = 0; i < getDifficultyValue(difficulty); i += 1) {
		icons.push(
			<Svg
				className={classNames(styles['smiley-icon'], styles[`theme-${theme}`])}
				id="smiley"
				key={i}
			/>
		);
	}

	return icons;
};

interface RecipeDifficultyIconProps {
	theme?: Theme;
	difficulty: CmsRecipeDifficulty;
	className?: string;
}

export const RecipeDifficultyIcon: React.VFC<RecipeDifficultyIconProps> = ({
	theme = 'dark',
	difficulty,
	className = '',
}) => {
	return (
		<span
			className={classNames(className, styles.wrapper, 'stack-inline')}
			data-testid="RecipeDifficultyIcon"
		>
			{getDifficultyIcons(difficulty, theme)}
		</span>
	);
};
